<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="意见反馈">
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="类别" prop="type_text" width="100px"></el-table-column>
                    <el-table-column  label="内容" prop="content"></el-table-column>
                    <el-table-column  label="联系人" prop="contact" width="100px"></el-table-column>
                    <el-table-column  label="联系电话" prop="contact_number" width="180px"></el-table-column>
                    <el-table-column  label="提交时间" prop="created_at" width="180px"></el-table-column>
                    <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                    <el-table-column width="220px"  fixed="right">
                        <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                        <template slot="header" slot-scope="scope">
                            <span style="color: #409EFF">操作</span>
                        </template>
                        <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                        <template slot-scope="scope">
                                <el-button size="mini" @click="handlerDelete(scope.$index, scope.row)"
                                   v-permission="'operating.feedbacks.delete'" type="danger"
                                >
                                    删除
                                </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { deleteFeedbacks,getFeedbacks } from '@/service/customer'
    import { parseTime } from '@/utils'
    export default {
        name: "List",
        components: {
        },
        data () {
            return {
                condition : {
                    page :1,
                    per_page : 10,
                    total : 0,
                },
                list: [],
                isLoading: false
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            /** 初始化数据请求 */
            async initData () {
                this.list = []
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                // 模拟fetch请求数据....
                let query = {
                    page : this.condition.page,
                    per_page : this.condition.per_page,
                }
                await getFeedbacks(query).then((data) => {
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        row.created_at = parseTime(new Date(row.created_at))
                        row.contact = (row.contact && row.contact.length > 0) ? row.contact : '--'
                        row.contact_number = (row.contact_number && row.contact_number.length > 0) ? row.contact_number : '--'
                    }
                    this.list = listData
                    console.log(this.condition)
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },
            handlerDelete(index, row){
                this.$confirm('删除后无法恢复，是否确认操作？', '提示').then(_ => {
                    deleteFeedbacks(row.id, {}).then((data) => {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.list.splice(index, 1)
                    }).catch(err => {
                        this.$message({
                            message: err.message || '删除失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }).catch(_ => {
                })
            },
        }
    }
</script>

<style scoped>

</style>
